var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "77px",
    viewBox: "0 0 62 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---2---Dashboard",
    transform: "translate(-1412.000000, -4150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1413.000000, 4151.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6087,7.5625 L25.9687,7.5625 L25.9687,8.9765 C14.9167,13.1555 6.8537,26.1545 6.8537,41.5525 C6.8537,56.9515 14.9167,69.9515 25.9687,74.1285 L25.9687,75.5425 L33.6087,75.5425 C48.3847,75.5425 60.3647,60.3255 60.3647,41.5525 C60.3647,22.7805 48.3847,7.5625 33.6087,7.5625",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6087,7.5625 L25.9687,7.5625 L25.9687,8.9765 C14.9167,13.1555 6.8537,26.1545 6.8537,41.5525 C6.8537,56.9515 14.9167,69.9515 25.9687,74.1285 L25.9687,75.5425 L33.6087,75.5425 C48.3847,75.5425 60.3647,60.3255 60.3647,41.5525 C60.3647,22.7805 48.3847,7.5625 33.6087,7.5625 Z",
    id: "Stroke-5",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,41.5528 C53.51,60.3248 41.531,75.5428 26.755,75.5428 C11.979,75.5428 1.10134124e-13,60.3248 1.10134124e-13,41.5528 C1.10134124e-13,22.7808 11.979,7.5628 26.755,7.5628 C41.531,7.5628 53.51,22.7808 53.51,41.5528",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,41.5528 C53.51,60.3248 41.531,75.5428 26.755,75.5428 C11.979,75.5428 1.10134124e-13,60.3248 1.10134124e-13,41.5528 C1.10134124e-13,22.7808 11.979,7.5628 26.755,7.5628 C41.531,7.5628 53.51,22.7808 53.51,41.5528 Z",
    id: "Stroke-7",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8713,41.5528 C47.8713,56.3678 38.4173,68.3788 26.7553,68.3788 C15.0943,68.3788 5.6403,56.3678 5.6403,41.5528 C5.6403,26.7378 15.0943,14.7278 26.7553,14.7278 C38.4173,14.7278 47.8713,26.7378 47.8713,41.5528",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8713,41.5528 C47.8713,56.3678 38.4173,68.3788 26.7553,68.3788 C15.0943,68.3788 5.6403,56.3678 5.6403,41.5528 C5.6403,26.7378 15.0943,14.7278 26.7553,14.7278 C38.4173,14.7278 47.8713,26.7378 47.8713,41.5528 Z",
    id: "Stroke-9",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "25.1821 7.563 33.6091 7.563 33.6091 5.224 25.1821 5.224"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-11",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "25.1821 7.563 33.6091 7.563 33.6091 5.224 25.1821 5.224"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    points: "22.0681 5.224 36.7231 5.224 36.7231 8.48210391e-14 22.0681 8.48210391e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "22.0681 5.224 36.7231 5.224 36.7231 8.48210391e-14 22.0681 8.48210391e-14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(26.644100, 18.965000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#FFFFFF",
    points: "0.111 0.5106 0.111 22.5876 15.849 16.8386"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-15",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    points: "0.111 0.5106 0.111 22.5876 15.849 16.8386"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6a9c8829f3110c4721ba2a9aacaf64ae.svg";
export { ForwardRef as ReactComponent };